import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const EmailIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M2 7C2 5.34315 3.34314 4 5 4H19C20.6569 4 22 5.34315 22 7V7.98005C22.0002 7.99276 22.0002 8.00546 22 8.01815V17C22 18.6569 20.6569 20 19 20H5C3.34314 20 2 18.6569 2 17V8.01817C1.99976 8.00547 1.99976 7.99275 2 7.98003V7ZM4 9.69951V17C4 17.5523 4.44771 18 5 18H19C19.5523 18 20 17.5523 20 17V9.69951L12.4856 13.8742C12.1836 14.0419 11.8164 14.0419 11.5144 13.8742L4 9.69951ZM20 7.4116V7C20 6.44772 19.5523 6 19 6H5C4.44771 6 4 6.44772 4 7V7.4116L12 11.856L20 7.4116Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

EmailIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(EmailIcon);
